import { _DIRECTION_KEY_RANGE, _EQUIPMENT_KEY_RANGE, _PART_KEY_RANGE } from "@/components/Table/static";
import * as ENUM from "@/enum/lib";

export const _GRAPH_SIDE_MENU_TABLE = ( that ) => {
    return [
        {
            index: 0,
            keyTitle: that.$t( 'rehabilitation.equipment' ),
            keyType: 'SelectBox',
            class: '',
            keyRange: _EQUIPMENT_KEY_RANGE.keyRange,
            values: _EQUIPMENT_KEY_RANGE.data[ ENUM.EQUIPMENT.REBLESS_HOME ]
        },
        {
            index: 1,
            keyTitle: that.$t( 'rehabilitation.exercise_position' ),
            keyType: 'SelectBox',
            class: '',
            keyRange: _PART_KEY_RANGE.keyRange,
            values: undefined
        },
        {
            index: 2,
            keyTitle: that.$t( 'rehabilitation.direction' ),
            keyType: 'SelectBox',
            class: '',
            keyRange: _DIRECTION_KEY_RANGE.keyRange,
            values: undefined
        }
    ]
}